import PressureTestsSpecification from './form'

const rigSupervisorsManagement = {
    name: 'Pressure Tests Specification',
    url: '#/pressureTestsSpecification',
    alias: 'pressureTestsSpecification',
    ico: 'fa fa-file-text-o',
    position: 'first-block',
    addRoute: true,
    routeUrl: 'pressureTestsSpecification',
    component: PressureTestsSpecification
}

try {
    require('./init')
    var ExtensionService = require('live/services/extension')

    ExtensionService.addAdminMenu(rigSupervisorsManagement)
} catch (e) {
    console.error(e)
}
